export const style = (theme) => ({
  list: {
    paddingTop: "0px",
  },
  selectedItem: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
  content: {
    padding: "1rem",
  },
  containerPlugin: {
    backgroundColor: "#FAFBFC",
    cursor: "pointer",
    margin: "8px 16px 8px 0",
    height: "max-content",
    width: "304px",
  },
  paper: {
    padding: "1rem",
  },
  image: {
    //  maxWidth: "-webkit-fill-available",
    height: "240px",
    width: "100%",
    borderRadius: "4px 4px 0 0",
    backgroundColor: "#dedede",
    textAlign: "center",
    // backgroundImage: "url(/images/noneImage.svg)"
  },
  search: {
    marginBottom: "1rem",
    marginTop: "8px",
  },
  containerContent: {
    fontSize: "12px",
    alignItems: "center",
    display: "flex",
    marginBottom: "8px",
    color: "#637188",
  },
  containerName: {
    alignItems: "center",
    display: "flex",
    marginBottom: "8px",
    fontWeight: "500",
  },
  icon: {
    backgroundPosition: "50%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "4px",
    display: "inline-block",
    textAlign: "center",
    height: "40px",
    width: "40px",
    marginRight: "8px",
  },
  button: {
    textTransform: "capitalize",
    backgroundColor: "#5aac44",
    borderRadius: "3px",
    fontWeight: "400",
    height: "24px",
    lineHeight: "16px",
    margin: "0",
    padding: "4px 8px",
    minWidth: "64px",
  },
  buttonRemove: {
    textTransform: "capitalize",
    backgroundColor: "#ff513f",
    borderRadius: "3px",
    fontWeight: "400",
    height: "24px",
    lineHeight: "16px",
    margin: "0",
    padding: "4px 8px",
    minWidth: "64px",
  },
  description: {
    display: "block",
    height: "54px",
    margin: "0 auto",
    fontSize: "14px",
    lineHeight: "18px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginBottom: "8px",
    color: "#5e6c84",
  },
  wrapPlugin: {
    display: "flex",
    flexFlow: "row",
    flexWrap: "wrap",
  },
  listItemText: {
    fontSize: "14px",
  },
  listItemTextHead: {
    fontSize: "14px",
    // fontWeight: "700",
  },
  listItemTextHeadSelected: {
    fontSize: "14px",
    // color: "#ed4d3b",
    fontWeight: "700",
  },
  titleForm: {
    fontSize: "20px",
    fontWeight: "600",
  },
  inputSearch: {
    border: "1px solid #d2d2d2",
    borderRadius: "3px",
    padding: "8px 16px",
    minHeight: "36px",
    width: "100%",
  },
  inputInputSearch: {
    fontSize: "14px",
  },
});
export const detailStyle = (theme) => ({
  image: {
    width: "100%",
    textAlign: "center",
  },
  containerTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  buttonRemove: {
    backgroundColor: "#ff513f",
  },
  button: {
    backgroundColor: "#5aac44",
  },
  paper: {
    padding: "24px",
    // margin: "36px",
  },
  containerContent: {
    margin: "16px 0",
  },
  nameTitle: {
    fontSize: "24px",
    fontWeight: "600",
  },
  titleForm: {
    fontWeight: "600",
    fontSize: "16px",
  },
  container: {
    padding: "0 32px",
  },
  linkCategory: {
    border: "1px solid #dfe1e6",
    fontSize: "12px",
    display: "inline-block",
    backgroundcolor: "#fff",
    padding: "4px 8px",
    marginRight: "4px",
    marginBottom: "4px",
    borderRadius: "4px",
    whiteSpace: "normal",
    overflow: "hidden",
    textDecoration: "none",
    cursor: "pointer",
  },
  download: {
    alignItems: "center",
    backgroundColor: "#dfe2e7",
    width: "fit-content",
    borderRadius: "3px",
    color: "#5e6c84",
    display: "flex",
    fontSize: "12px",
    height: "24px",
    lineHeight: "14px",
    marginBottom: "4px",
    padding: "0 12px",
    whiteSpace: "nowrap",
    marginTop: "8px",
  },
  shortDescription: {
    fontSize: "14px",
    color: "#172b4d",
    lineHeight: "20px",
  },
  contactPolicy: {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    cursor: "pointer",
    color: "#172b4d",
  },
  icon: {
    marginRight: "8px",
    width: "1rem",
    color: "#42526e",
  },
});
